import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';

const SelectValidPreServicio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            label: 'Nro Pre-Servicio',
            value: 'id_t',
            tipo: 'texto'
        },
        {
            label: 'Nro Cuenta',
            value: 'cuentaId_t',
            tipo: 'texto'
        },
        {
            label: 'Nombre',
            value: 'nombre_t',
            tipo: 'texto'
        },
        {
            label: 'Categoria',
            value: 'categoria_t',
            tipo: 'select'
        },
        {
            label: 'Dirección',
            value: 'direccion_t',
            tipo: 'texto'
        },
        {
            label: 'Nivel Vip',
            value: 'nivelVip_t',
            tipo: 'select'
        },
        {
            label: 'Coordenadas',
            value: 'coordenadas_t',
            tipo: 'texto'
        },
        {
            label: 'Celular',
            value: 'celular_t',
            tipo: 'texto'
        },
        {
            label: 'Correo',
            value: 'contactoEmail_t',
            tipo: 'texto'
        },
        {
            label: 'Codigo Postal',
            value: 'codpostal_t',
            tipo: 'select'
        },
        {
            label: 'Canal de Comunicacion',
            value: 'contratistaSoft_t',
            tipo: 'select'
        },
        {
            label: 'Cargo Instalacion',
            value: 'cargoinstalacion_t',
            tipo: 'select'
        },
        {
            label: 'Nivel Autorizacion',
            value: 'nivelAutorizacion_t',
            tipo: 'select'
        },
        {
            label: 'Estado',
            value: 'estadoServicio_t',
            tipo: 'select'
        },
        {
            label: 'Sub-Estado',
            value: 'subEstadoServicio_t',
            tipo: 'select'
        },
        {
            label: 'Servicio de Cambio de Titular',
            value: 'cambDomServicioId_t',
            tipo: 'texto'
        },
        {
            label: 'Autorizado Por',
            value: 'autorizadoxPersonalId_t',
            tipo: 'select'
        },
        {
            label: 'Creado Por',
            value: 'createdPersonaId_t',
            tipo: 'select'
        },
        {
            label: 'Modificado Por',
            value: 'updatedPersonaId_t',
            tipo: 'select'
        },
    ]

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectValidPreServicio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectValidPreServicio;